import AdvancedController from "./advanced-controller"
import gsap from 'gsap';
import { Breakpoints } from './breakpoints';
import { scrollTo } from "./anchor-scroll-to";

export default class FilterController extends AdvancedController {

  static targets = ['filterToggle', 'filterToggleText', 'filterList', 'loadingIndicator'];

  static values = {
    isFilterVisible: { type: Boolean, default: false },
    isFlyoutVisible: { type: Boolean, default: false },
    isFlyoutActive: { type: Boolean, default: false },
    isToggleActive: Boolean,
    activeFilters: { type: Number, default: 0 },
    filterToggleText: String
  }

  connect() {
    super.connect();
    if (this.hasFilterToggleTextTarget) {
      this.filterToggleTextValue = this.filterToggleTextTarget.innerHTML.trim();
    }

    this.breakpoints = new Breakpoints();
    this.isFlyoutActiveValue = this.breakpoints.breakpointDown('sm')
    this.breakpoints.on('changed', () => {
      this.isFlyoutActiveValue = this.breakpoints.breakpointDown('sm');
    })
    this.isFilterVisibleValue = !this.isToggleActiveValue;

    this._addEventListeners();

    // Add event listeners for custom events dispatched from facet-scripts.js
    document.addEventListener('facetwp-flyout-opened', () => {
      this.isFlyoutVisibleValue = true;
    });

    document.addEventListener('facetwp-flyout-closed', () => {
      if (this.isToggleActiveValue && !this.isFlyoutActiveValue) {
        this.filterToggleTarget.classList.toggle('active', this.isFlyoutVisibleValue)
      } else {
        this.filterToggleTarget.classList.toggle('active', false)
      }
      this.isFlyoutVisibleValue = false;
    });
  }

  onFilterToggle(e) {
    e.preventDefault();
    if (this.isFlyoutActiveValue) {
      const action = this.isFlyoutVisibleValue ? 'close' : 'open'
      FWP.flyout[action]();
    } else {
      this.isFilterVisibleValue = !this.isFilterVisibleValue;
    }
    this.filterToggleTarget.classList.toggle('active')
  }

  resetFilter(e) {
    e.preventDefault();
    FWP.reset();
  }

  activeFiltersValueChanged() {
    this._updateFilterToggleText()
  }

  isFilterVisibleValueChanged(current, old) {
    if (typeof old === 'undefined') {
      return;
    }
    this._updateFilterToggleText()
    if (current) {
      gsap.to(this.filterListTarget, { height: 'auto', autoAlpha: 1, duration: 0.5 });
    } else {
      gsap.to(this.filterListTarget, { height: '0', autoAlpha: 0, duration: 0.5 });
    }
  }

  isFlyoutActiveValueChanged(current, old) {
    if (typeof old === 'undefined') {
      return;
    }

    if (current) {
      if (this.isFilterVisibleValue && this.isToggleActiveValue) {
        FWP.flyout.open();
      }
      this.isFilterVisibleValue = false
    }
    else {
      this.isFilterVisibleValue = this.isToggleActiveValue ? this.isFlyoutVisibleValue : true;
      FWP.flyout.close();
    }
  }

  _updateActiveFacets() {
    let filters = Object.assign({}, FWP_HTTP.get)
    if (filters.hasOwnProperty('_paged')) {
      delete filters._paged;
    }
    if (filters.hasOwnProperty('_sort')) {
      delete filters._sort;
    }
    if (filters.hasOwnProperty('_s')) {
      delete filters._s;
    }
    this.activeFiltersValue = Object.keys(filters).length
  }

  _updateFilterToggleText() {
    if (this.filterToggleTextValue != '') {
      if (this.activeFiltersValue === 0 || this.isFilterVisibleValue === true) {
        this.filterToggleTextTarget.innerHTML = this.filterToggleTextValue;
      } else {
        this.filterToggleTextTarget.innerHTML = `${this.filterToggleTextValue} (${this.activeFiltersValue})`;
      }
    }
  }

  _createFSelects() {
    const fSelectOpts = FWP.hooks.applyFilters('facetwp/set_options/fselect', {}, {});
    const fselects = document.querySelectorAll('.fselect');

    fselects.forEach((el) => {
      const facetName = el.getAttribute('data-name');
      if (facetName === 'sort') {
        el.querySelector(`option[value=default]`).classList.add('hidden');
        el.querySelector(`option[value=${FWP.extras.sort}]`).setAttribute('selected', 'selected');
      }
      fSelect(el, fSelectOpts);
    });
  }

  _isLoaded() {
    const facets = this.element.querySelectorAll('.facetwp-facet');
    // If no facets are found, consider it not loaded or empty
    if (facets.length === 0) {
      return false;
    }
    // Check if any facet has child elements
    for (let i = 0; i < facets.length; i++) {
      if (facets[i].children.length > 0) {
        // Found at least one facet with children, return true
        return true;
      }
    }
    // If the loop completes, all facets are empty, return false
    return false;
  }

  _addEventListeners() {

    const eventCallback = () => {

      this._createFSelects();
      this._updateActiveFacets();
      if (this.hasLoadingIndicatorTarget) {
        this.loadingIndicatorTarget.classList.toggle('-is-loading', false)
      }
      this.element.classList.toggle('-is-loading', false)

      if (FWP.enable_scroll == true) {
        let offset = this.breakpoints.breakpointDown('md') ? 95 : 215;
        scrollTo('[data-controller="filter"]', offset);
      }

      document.querySelectorAll('.facetwp-facet').forEach((item) => {
        const facetType = item.getAttribute('data-type');
        if (facetType !== 'checkboxes') {
          return;
        }
        const facet_name = item.getAttribute('data-name');
        const facet_label = FWP.settings.labels[facet_name];
        if ('undefined' !== typeof FWP.settings.num_choices[facet_name] && FWP.settings.num_choices[facet_name] > 0 && document.querySelector('.facetwp-label[data-for="' + facet_name + '"]') === null) {
          item.insertAdjacentHTML('beforebegin', '<span class="facetwp-label" data-for="' + facet_name + '">' + facet_label + '</span>');
        } else if ('undefined' !== typeof FWP.settings.num_choices[facet_name] && !FWP.settings.num_choices[facet_name] > 0) {
          const toRemove = document.querySelector('.facetwp-label[data-for="' + facet_name + '"]')
          if (toRemove != null) {
            toRemove.remove();
          }
        }
      });
    }

    if (!this._isLoaded()) {
      document.addEventListener('facetwp-loaded', eventCallback);
    } else {
      eventCallback();
    }

    document.addEventListener('facetwp-refresh', () => {
      if (this.hasLoadingIndicatorTarget) {
        this.loadingIndicatorTarget.classList.toggle('-is-loading', true)
      }
      this.element.classList.toggle('-is-loading', true)

      FWP.enable_scroll = FWP.soft_refresh;
    });
  }

}
